<template>
  <div class="textarea-wrapper">
    <Field
        v-model="inputValue"
        type="textarea"
        :rows="rows"
        :maxlength="maxlength"
        :placeholder="placeholder"
        class="sms-content"
        clearable
        :rules="internalRules"
    />

    <img
        class="bg-img"
        :src="bgImage || defaultImage"
        alt=""
    >

    <div class="textarea-footer">
      <span class="count-text">{{ currentLength }}/{{ maxlength }}</span>
      <span class="price-tip">{{ showText }}</span>
    </div>
  </div>
</template>

<script setup>
import { Field } from 'vant'
import { computed, ref, watch } from 'vue'

const props = defineProps({
  modelValue: { type: String, default: '' },
  rows: { type: [String, Number], default: 6 },
  maxlength: { type: [String, Number], default: 5000 },
  placeholder: { type: String, default: '请输入内容' },
  bottomText: { type: String, default: '' },
  unitPrice: { type: [String, Number], default: '' },
  bgImage: { type: String, default: '' },
  required: { type: Boolean, default: false },
  requiredMessage: { type: String, default: '请先填写传话内容' }
})

const emit = defineEmits(['update:modelValue'])

// 本地维护值，防止被清空
const inputValue = ref(props.modelValue || '')

// 监听父组件值变化
watch(
    () => props.modelValue,
    (val) => {
      if (val !== inputValue.value) {
        inputValue.value = val
      }
    }
)

// 监听输入框变化，同步给父组件
watch(
    () => inputValue.value,
    (val) => {
      emit('update:modelValue', val)
    }
)

// 校验规则
const internalRules = computed(() => {
  if (props.required) {
    return [{ required: true, message: props.requiredMessage }]
  }
  return []
})

// 默认图片
const defaultImage = require('@/assets/image/02.png')

// 字数统计
const currentLength = computed(() => {
  return (inputValue.value && inputValue.value.length) || 0
})

// 条数计算
const totalCount = computed(() => {
  const len = currentLength.value
  return len === 0 ? 0 : Math.ceil(len / 45)
})

// 总价
const totalPrice = computed(() => {
  return (totalCount.value * Number(props.unitPrice)).toFixed(2)
})

// 底部显示文字
const showText = computed(() => {
  if (props.bottomText) return props.bottomText
  if (props.unitPrice || props.unitPrice === 0) {
    return '按照45个字一条计算，共' + totalCount.value + '条' + totalPrice.value + '元'
  }
  return ''
})
</script>

<style scoped>
.textarea-wrapper {
  background-color: #fff;
  border-radius: 16px;
  overflow: hidden;
  position: relative;
}

.bg-img {
  position: absolute;
  right: 15px;
  bottom: 40px;
  width: 120px;
  height: 120px;
  z-index: 1;
  pointer-events: none;
}

.sms-content {
  background: transparent !important;
  position: relative;
  z-index: 2;
}
.sms-content :deep(.van-field__body) {
  border-bottom: none !important;
}
.sms-content :deep(.van-field__control-wrapper) {
  min-height: 180px;
}

.textarea-footer {
  padding: 10px 15px 15px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  background-color: #fff;
  position: relative;
  z-index: 2;
}

.count-text {
  font-size: 10px;
  color: #999;
  margin-bottom: 6px;
}

.price-tip {
  font-size: 10px;
  color: #EC81A7;
}
</style>